module.exports = __webpack_public_path__ + "img/tether.c1755607.svg";